(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.
            state('workshops', {
                parent: 'app',
                url: '/workshops',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/portal/workshops/workshops.html',
                        controller: 'WorkshopsController',
                        controllerAs: 'vm'
                    },
                    'actual@workshops': {
                        templateUrl: 'app/portal/workshops/actual.html'//,
                        // controller: 'WorkshopsController',
                        // controllerAs: 'vm'
                    },
                    'archive@workshops': {
                        templateUrl: 'app/portal/workshops/archive.html'//,
                        // controller: 'WorkshopsController',
                        // controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();
